export default __webpack_public_path__ + "static/media/eudelegationDE.82f7f6fd.png";